var map = {
	"./bg-standby-green.svg": "80d9",
	"./loader.svg": "1572",
	"./location-pin.svg": "90f4",
	"./logo-icon.svg": "4422",
	"./logo-text.svg": "9a6d",
	"./logo.svg": "38a7",
	"./phone.svg": "aaed",
	"./symbol-profile.svg": "b4a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa35";